import styled from 'styled-components';
import Modal from 'react-modal';
import { useTranslation } from '@hooks';

import { CloseIcon, TickIcon } from '@components/icons';
import { RightModal } from '@components/ui';
import { Caption2, Text2 } from '@components/styles/Typography';

const sortOptions = [
    {
        title: {
            en: 'Newest',
            tr: 'Yeniler',
        },
        value: 'newest',
    },
    {
        title: {
            en: 'Price: Low to High',
            tr: 'Fiyat: Düşükten Yükseğe',
        },
        value: 'priceAsc',
        testid: 'sort-option-priceLowToHigh',
    },
    {
        title: {
            en: 'Price: High to Low',
            tr: 'Fiyat: Yüksekten Düşüğe',
        },
        value: 'priceDesc',
    },

    {
        title: {
            en: 'By Likes',
            tr: 'Beğeniye Göre',
        },
        value: 'favCount',
    },
    {
        title: {
            en: 'By Color',
            tr: 'Renge göre',
        },
        value: 'colourCount',
        testid: 'sort-option-colour',
    },
];
Modal.setAppElement('#__next');

const SortOptionModal = ({
    isOpen,
    onOrderChange,
    onCloseSortModal,
    selectedOrder,
    title,
}) => {
    const { locale } = useTranslation();

    return (
        <RightModal
            isOpen={isOpen}
            closeModal={onCloseSortModal}
            noOverlay
            width="400px"
        >
            <SortMenuHeader>
                <Text2>{title}</Text2>
                <button onClick={onCloseSortModal} type="button">
                    <CloseIcon width="12px" height="12px" />
                </button>
            </SortMenuHeader>

            <OptionsWrapper>
                {sortOptions.map((option) => {
                    const isSelected = option.value === selectedOrder;
                    return (
                        <SortOption
                            key={option.value}
                            isSelected={isSelected}
                            onClick={() => onOrderChange(option.value)}
                            data-testid={option.testid}
                        >
                            <Caption2>{option.title[locale]}</Caption2>
                            {isSelected && (
                                <TickIcon
                                    fill="black"
                                    width="12px"
                                    height="12px"
                                />
                            )}
                        </SortOption>
                    );
                })}
            </OptionsWrapper>
        </RightModal>
    );
};

const SortMenuHeader = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 59px;
    button {
        background: transparent;
        border: none;
        outline: none;
    }
    @media (min-width: 1025px) {
        box-shadow: 0 3px 6px 0 rgba(40, 49, 59, 0.06);
    }
`;
const OptionsWrapper = styled.div`
    margin-top: 73px;
    padding: 0 20px;
`;
const SortOption = styled.button`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 34px;
    background: ${({ isSelected, theme }) =>
        isSelected ? `${theme.colors.tertiaryVariant}` : 'transparent'};
    padding: 0 6px;
    border: none;
`;
export default SortOptionModal;
